export class VehicleAnnotationRequest {
  constructor(
    public readonly annotations: string
  ) {
  }
}
